import { EntityTileProps } from '../../../../layout/interfaces/tile';
import { RawDestinationType } from '../../interfaces/destination';

export function EdgeDestinationTypeTilesFactory(
  destinationTypes: RawDestinationType[]
): Array<EntityTileProps> {
  return destinationTypes.map((destinationType, index) => ({
    id: destinationType.type,
    sortOrder: index,
    thumbnail: destinationType.logo_url,
    darkModeThumbnail: destinationType.dark_mode_logo_url,
    title: destinationType.display_name,
    data: { ...destinationType },
    metaData: {
      enterpriseNodeLogo: true,
      primaryColor: null,
      darkModePrimaryColor: null
    }
  }));
}
